/* assets/j_cart-core.js
   Base cart helper for NJC custom cart/gift features.
   Keep this file loaded before all j_ cart and gift modules.
*/

(function () {
  if (window.JCartCore) return;

  var busyCount = 0;
  var debug = false;

  function log() {
    if (!debug) return;
    console.log.apply(console, ['[JCartCore]'].concat([].slice.call(arguments)));
  }

  function setDebug(value) {
    debug = !!value;
  }

  function emit(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
      window.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (e) {
      var event = document.createEvent('Event');
      event.initEvent(name, true, true);
      document.dispatchEvent(event);
      window.dispatchEvent(event);
    }
  }

  function setBusy(isBusy) {
    if (isBusy) {
      busyCount += 1;
    } else {
      busyCount = Math.max(0, busyCount - 1);
    }

    emit('j:cart:busy', {
      busy: busyCount > 0,
      count: busyCount
    });
  }

  function isBusy() {
    return busyCount > 0;
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart.');
      return response.json();
    });
  }

  function addItem(data) {

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add item.');
        return response.json();
      })
      .then(function (cartData) {
        emit('j:cart:mutated', { action: 'add', cart: cartData });
        emit('cart:refresh', { source: 'j_cart-core' });
        return cartData;
      })
  }

  function changeItem(data) {

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to update item.');
        return response.json();
      })
      .then(function (cart) {
        emit('j:cart:mutated', { action: 'change', cart: cart });
        emit('cart:refresh', { source: 'j_cart-core' });
        return cart;
      })
  }

  function formatMoney(cents, symbol) {
    var amount = Number(cents || 0) / 100;
    return (symbol || '$') + amount.toFixed(2);
  }

  window.JCartCore = {
    emit: emit,
    setBusy: setBusy,
    isBusy: isBusy,
    getCart: getCart,
    addItem: addItem,
    changeItem: changeItem,
    formatMoney: formatMoney,
    setCheckoutDisabled: setCheckoutDisabled,
    isMiniCartOpen: isMiniCartOpen,
    setMiniCartOverlay: setMiniCartOverlay,
    isCheckoutTarget: isCheckoutTarget,
    blockEvent: blockEvent,
    patchCartFetch: patchCartFetch,
    setDebug: setDebug,
    log: log
  };

  window.JCartGuard = {
    on: function () {
      setBusy(true);
    },
    off: function () {
      setBusy(false);
    },
    isBusy: isBusy
  };

    function setCheckoutDisabled(disabled) {
    var selectors = [
      'button[name="checkout"]',
      'a[href^="/checkout"]',
      '[data-checkout]',
      '.cart__checkout-button',
      '.mini-cart__checkout',
      '.t4s-btn__checkout'
    ];

    selectors.forEach(function (selector) {
      var items = document.querySelectorAll(selector);

      items.forEach(function (item) {
        if (disabled) {
          item.setAttribute('aria-disabled', 'true');
          item.setAttribute('data-j-cart-busy', '1');

          if (item.tagName === 'BUTTON' || item.type === 'submit') {
            item.disabled = true;
          }

          item.style.pointerEvents = 'none';
          item.style.opacity = '0.6';
        } else {
          item.removeAttribute('aria-disabled');
          item.removeAttribute('data-j-cart-busy');

          if (item.tagName === 'BUTTON' || item.type === 'submit') {
            item.disabled = false;
          }

          item.style.pointerEvents = '';
          item.style.opacity = '';
        }
      });
    });
  }

  document.addEventListener('j:cart:busy', function (event) {
    var detail = event.detail || {};
    setCheckoutDisabled(!!detail.busy);
  });

    function isMiniCartOpen() {
    var selectors = [
      '#t4s-mini_cart[aria-hidden="false"]',
      '.t4s-drawer--open',
      '.t4s-minicart-is-show',
      '[data-cart-wrapper][aria-hidden="false"]'
    ];

    return selectors.some(function (selector) {
      return !!document.querySelector(selector);
    });
  }

  function ensureMiniCartOverlay() {
    var overlay = document.getElementById('j_cart-overlay');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.id = 'j_cart-overlay';
    overlay.className = 'j_cart-overlay';
    overlay.setAttribute('aria-hidden', 'true');

    overlay.innerHTML =
      '<div class="j_cart-overlay__box" role="status" aria-live="polite">' +
        '<span class="j_cart-overlay__spinner" aria-hidden="true"></span>' +
        '<span>Updating cart...</span>' +
      '</div>';

    document.body.appendChild(overlay);
    return overlay;
  }

  function setMiniCartOverlay(show) {
    var overlay = ensureMiniCartOverlay();

    if (show && isMiniCartOpen()) {
      overlay.removeAttribute('aria-hidden');
      overlay.classList.add('is-active');
    } else {
      overlay.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-active');
    }
  }

  document.addEventListener('j:cart:busy', function (event) {
    var detail = event.detail || {};
    setMiniCartOverlay(!!detail.busy);
  });

    function isCheckoutTarget(event) {
    if (!event || !event.target || !event.target.closest) return null;

    return (
      event.target.closest('button[name="checkout"]') ||
      event.target.closest('a[href^="/checkout"]') ||
      event.target.closest('[data-checkout]') ||
      event.target.closest('.t4s-btn__checkout')
    );
  }

  function blockEvent(event) {
    event.preventDefault();
    event.stopPropagation();

    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }
  }

  ['mousedown', 'touchstart', 'click'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (!isCheckoutTarget(event)) return;

      if (isBusy()) {
        blockEvent(event);
      }
    }, true);
  });
    function patchCartFetch() {
    if (window.__j_cart_fetch_patched) return;
    if (!window.fetch) return;

    window.__j_cart_fetch_patched = true;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      var isCartWrite =
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1;

      if (isCartWrite) setBusy(true);

      return originalFetch.apply(this, arguments)
        .then(function (response) {
          if (isCartWrite) {
            emit('j:cart:mutated', { url: url });
            emit('cart:refresh', { source: 'j_cart-core-fetch' });
          }

          return response;
        })
        .finally(function () {
          if (isCartWrite) setBusy(false);
        });
    };
  }

  patchCartFetch();

})();